import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import { useSelector } from "react-redux";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { ClientInfo, getImageUrl, trackEvent } from "../Utility/Utility";
import { encryptURLParam } from "../../Common/Axios/encrypt";

const TrendingGiftCardOptimized = ({
  product,
  handleShow,
  productValues,
  setPageNumber,
  totalCount,
}) => {
  const navigate = useNavigate();
  // const [notFoundStates, setNotFoundStates] = useState([]);
  const translation = getTranslationData();
  const loaderRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (totalCount && product) {
      setHasMore(product.length < totalCount);
    } else if (totalCount === 0) {
      setHasMore(false);
    }
  }, [product?.length, totalCount]); // Added totalCount dependency

  // IntersectionObserver for infinite scroll
  useEffect(() => {
    if (!hasMore || !product || product.length >= totalCount) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          hasMore &&
          product.length < totalCount
        ) {
          setPageNumber((prev) => prev + 1);
        }
      },
      {
        root: null,
        rootMargin: "300px",
        threshold: 0.1,
      }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
      observer.disconnect();
    };
  }, [hasMore, setPageNumber, product, totalCount]);

  const handleSubmit = (item) => {
    const productId = item?.id?.toString();
    const finalProductId =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? productId
        : encryptURLParam(productId);

    clientConfigurationData?.enableQuickBy
      ? handleShowModal(item)
      : navigate(`/giftcard?productId=${finalProductId}`, { state: { item } });
  };
  // const productDiscount = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );

  const getMaxPrice = (priceDenominations) => {
    if (priceDenominations) {
      const pricesArray = priceDenominations?.split(",");
      const pricesNumbers = pricesArray?.map(Number);
      return Math.max(...pricesNumbers);
    }
  };
  const getMinPrice = (priceDenominations) => {
    if (priceDenominations) {
      const pricesArray = priceDenominations?.split(",");
      const pricesNumbers = pricesArray?.map(Number);

      return Math.min(...pricesNumbers);
    }
  };

  const calculatePointsern = (item, isString) => {
    const productId = item.id;
    const maxPrice = getMaxPrice(item?.priceDenominations);
    const minPrice = getMinPrice(item?.priceDenominations);
    const discountEntry = product?.find((entry) => entry.id === productId);
    if (discountEntry) {
      if (discountEntry.minEarnPoints > 0) {
        return isString
          ? `${Math.round(
            (discountEntry.minEarnPoints / minPrice) *
            (maxPrice - (maxPrice * discountEntry.customerDiscount) / 100)
          )} ${translation?.pts}`
          : Math.round(
            (discountEntry.minEarnPoints / minPrice) *
            (maxPrice - (maxPrice * discountEntry.customerDiscount) / 100)
          );
      }
    }
    return null;
  };

  const calculatePoints = (item, isString) => {
    const productId = item.id;
    const minPrice = getMinPrice(item?.priceDenominations);

    const discountEntry = product?.find((entry) => entry.id === productId);

    if (discountEntry) {
      if (discountEntry.maxEarnPoints > 0) {
        // apply discount
        let discountedPrice =
          minPrice - (minPrice * discountEntry.customerDiscount) / 100;

        // apply convenience fee
        let priceWithFee =
          discountedPrice +
          (discountedPrice * (discountEntry.convenienceFee || 0)) / 100;

        // apply gst
        let finalPrice =
          priceWithFee + (priceWithFee * (discountEntry.gst || 0)) / 100;
        //convert into points
        const points = Math.round(
          (discountEntry.maxEarnPoints / minPrice) * finalPrice
        );

        return isString ? `${points} ${translation?.pts}` : points;
      }
    }
    return null;
  };

  const calculateDiscount = (item) => {
    const productId = item.id;
    const minPrice = getMinPrice(item?.priceDenominations);
    const discountEntry = product?.find((entry) => entry.id === productId);
    if (discountEntry) {
      const discountedPrice =
        minPrice - (minPrice * discountEntry.customerDiscount) / 100;
      return parseFloat(minPrice.toFixed(2)).toString();
    } //using min point
    return null;
  };
  const handleShowModal = (item) => {
    handleShow(false);
    productValues(item);
  };

  // const handleImageError = (index) => {
  //   setNotFoundStates((prevState) => {
  //     const newState = [...prevState];
  //     newState[index] = true;
  //     return newState;
  //   });
  // };

  const imageError = (e) => {
    e.target.onerror = null; // Prevent infinite loop if fallback fails
    e.target.src = defaultImage; // Set fallback
  };

  const [nav, setNav] = useState();
  const clientConfigurationData = useSelector(
    (state) => state.clientConfigurationReducer.clientConfigurationData?.[0]
  );

  useEffect(() => {
    setNav(clientConfigurationData?.enableQuickBy);

  }, [clientConfigurationData]);

  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview"
  )?.configValue;
  const isBurn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isburn"
  )?.configValue;
  const isEarn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearn"
  )?.configValue;

  const productList = Array.isArray(product)
    ? product?.map((item, index) => (
      <div
        key={index}
        className="col-lg-3 col-6 mb-3 pad-0 card_mob_p custom-col"
      >
        <div className="giftcardbox feat-gift-card-sz1">
          <div onClick={() => handleSubmit(item)}>
            {/* {notFoundStates[index] && (
              <div className="info-icon">
                <i className="fa fa-info-circle" aria-hidden="true"></i>
                <div>{translation?.errorInImagePath}</div>
              </div>
            )} */}
            {item?.customerDiscount !== 0 && (
              <div className="position-absolute top-1 start-50 translate-middle-x discountOff2">
                {item?.customerDiscount}% {translation?.off}
              </div>
            )}
            <div className="mt-2 p-1">
              <img
                // src={notFoundStates[index] ? defaultImage : item?.small}
                src={getImageUrl(item?.small)}
                onError={(e) => {
                  //handleImageError(index);
                  imageError(e);
                }}
                alt={item?.name}
                className="w-100 trendCardImg trend-rad"
              />
            </div>
            <h4
              className={`card-name ${clientConfigurationData?.showVoucherNameInLine === 2
                  ? "eclips_line-two"
                  : "eclips_line-one"
                }`}
              title={item?.name}
            >
              {item?.name}
              {/* {item?.name?.length >= 20
                ? item?.name?.substring(0, 50) + "..."
                : item?.name} */}
            </h4>
          </div>
          <div className="fixFromBottom">
            {isEarn &&
              isEarn === 1 &&
              isBurn === 1 &&
              isEarnView &&
              isEarnView === 1 ? (
              <>
                {calculatePointsern(item, false) ? (
                  <span
                    className={`aapoForMob trend-mb ${!calculatePoints(item, false) ? "m-b-2-5" : ""
                      }`}
                  >
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#earnpoints"
                      className="earn-point1"
                      onClick={(e) => {
                        e.preventDefault();
                        nav ? handleShowModal(item) : handleSubmit(item);
                      }}
                    >
                      {translation?.buyAndEarnUpTo}{" "}
                      {calculatePointsern(item, true)}
                    </Link>
                  </span>
                ) : null}
                {/* Starting From */}
                {!calculatePointsern(item, false) &&
                  !calculatePoints(item, false) && (
                    <span
                      className={`aapoForMob trend-mb ${!calculatePointsern(item, false) &&
                          !calculatePoints(item, false)
                          ? "m-b-2-5"
                          : ""
                        }`}
                    >
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#earnpoints"
                        className="start-point1"
                        onClick={(e) => {
                          e.preventDefault();
                          nav ? handleShowModal(item) : handleSubmit(item);
                        }}
                      >
                        {translation?.startingFrom} ₹{" "}
                        {calculateDiscount(item)}
                      </Link>
                    </span>
                  )}
                {/* Redeem Points */}
                {calculatePoints(item, false) ? (
                  <span
                    className={`earn_upto_points trend-mb ${!calculatePointsern(item, false) ? "m-b-2" : ""
                      }`}
                  >
                    {calculatePointsern(item, false) ? (
                      <span>{translation?.orRedeemFrom} </span>
                    ) : (
                      <span>{translation?.redeemFrom} </span>
                    )}
                    <span className="pts-col">
                      {calculatePoints(item, true)}
                    </span>
                  </span>
                ) : null}
              </>
            ) : (
              <>
                {!isEarnView ||
                  !isEarn ||
                  (isEarn === 2 && isEarnView === 2 && isBurn === 2) ? (
                  <>
                    <span className={`aapoForMob trend-mb`}>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#earnpoints"
                        className="start-point1"
                        onClick={(e) => {
                          e.preventDefault();
                          nav ? handleShowModal(item) : handleSubmit(item);
                        }}
                      >
                        {translation?.startingFrom} ₹{" "}
                        {calculateDiscount(item)}
                      </Link>
                    </span>
                  </>
                ) : (
                  <>
                    {isBurn === 1 ? (
                      <>
                        <span className={`aapoForMob trend-mb`}>
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#earnpoints"
                            className="start-point1"
                            onClick={(e) => {
                              e.preventDefault();
                              nav
                                ? handleShowModal(item)
                                : handleSubmit(item);
                            }}
                          >
                            {translation?.startingFrom} ₹{" "}
                            {calculateDiscount(item)}
                          </Link>
                        </span>
                        {/* Redeem Points */}
                        {calculatePoints(item, false) ? (
                          <span
                            className={`earn_upto_points trend-mb ${!calculatePointsern(item, false) ? "m-b-2" : ""
                              }`}
                          >
                            {calculatePointsern(item, false) ? (
                              <span>{translation?.orRedeemFrom} </span>
                            ) : (
                              <span>{translation?.redeemFrom} </span>
                            )}
                            <span className="pts-col">
                              {calculatePoints(item, true)}
                            </span>
                          </span>
                        ) : null}
                      </>
                    ) : (
                      <>
                        {isEarnView === 1 ? (
                          <>
                            {calculatePointsern(item, false) ? (
                              <span
                                className={`aapoForMob trend-mb ${!calculatePoints(item, false)
                                    ? "m-b-2-5"
                                    : ""
                                  }`}
                              >
                                <Link
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#earnpoints"
                                  className="earn-point1"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    nav
                                      ? handleShowModal(item)
                                      : handleSubmit(item);
                                  }}
                                >
                                  {translation?.buyAndEarnUpTo}{" "}
                                  {calculatePointsern(item, true)}
                                </Link>
                              </span>
                            ) : null}
                            {!calculatePointsern(item, false) &&
                              !calculatePoints(item, false) && (
                                <span
                                  className={`aapoForMob trend-mb ${!calculatePointsern(item, false) &&
                                      !calculatePoints(item, false)
                                      ? "m-b-2-5"
                                      : ""
                                    }`}
                                >
                                  <Link
                                    to="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#earnpoints"
                                    className="start-point1"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      nav
                                        ? handleShowModal(item)
                                        : handleSubmit(item);
                                    }}
                                  >
                                    {translation?.startingFrom} ₹{" "}
                                    {calculateDiscount(item)}
                                  </Link>
                                </span>
                              )}
                          </>
                        ) : (
                          <>
                            {calculatePointsern(item, false) ? (
                              <span
                                className={`aapoForMob trend-mb ${!calculatePoints(item, false)
                                    ? "m-b-2-5"
                                    : ""
                                  }`}
                              >
                                <Link
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#earnpoints"
                                  className="earn-point1"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    nav
                                      ? handleShowModal(item)
                                      : handleSubmit(item);
                                  }}
                                >
                                  {translation?.buyAndEarnUpTo}{" "}
                                  {calculatePointsern(item, true)}
                                </Link>
                              </span>
                            ) : null}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}

            <button
              className="custom-button select-btn-fix"
              onClick={() => handleSubmit(item)}
            >
              {translation?.select}
            </button>
          </div>
        </div>
      </div>
    ))
    : null;

  return (
    <>
      {productList}

      {/* Loader/Observer element for infinite scroll */}
      {hasMore && Array.isArray(product) && product.length > 0 && (
        <div
          ref={loaderRef}
          className="col-12 text-center py-4"
          style={{ minHeight: "50px" }}
        ></div>
      )}
    </>
  );
};

export default TrendingGiftCardOptimized;
